import { PageRequest } from "@/components/tasks-kanban/adapter";
import { SortColumnRequest } from "./SortColumnRequest";

export class ZmkTaskByPerformerListRequest {
  GlobalStatusIds!: Array<string>;
  ProjectId?: number;
  NamespaceId?: string;
  TypeIds!: Array<string>;
  DifficultyIds!: Array<string>;
  QueueIds!: Array<string>;
  TagIds!: Array<number>;
  PerformerIds!: Array<number>;
  Search!: string;
  IncludeCurrentUserId: boolean = false;
  StatusIds!: Array<number>;
  PriorityIds!: Array<number>;
  PerformerPage!: PageRequest;
  TaskPage!: PageRequest;
  Sort!: SortColumnRequest;
  constructor(obj?: Partial<ZmkTaskByPerformerListRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
